// extracted by mini-css-extract-plugin
module.exports = {"root":"EventsSectionStreamHeader__root--3vMFO"};